module.exports = __webpack_public_path__ + "01_glasses_red.b459f8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/01_glasses_red.png
// module id = OUqc
// module chunks = 0